import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
import './index.css'
import App from './App.tsx'

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN as string | undefined,
  environment: 'production',
  release: import.meta.env.VITE_SENTRY_RELEASE as string | undefined,
  tracesSampleRate: 0.1,
  integrations: [
    Sentry.browserTracingIntegration(),
  ],
  beforeSend(event) {
    // Strip Authorization header from captured request and breadcrumbs
    if (event.request?.headers) {
      delete (event.request.headers as Record<string, string>)['Authorization'];
    }
    if (event.breadcrumbs) {
      for (const b of event.breadcrumbs) {
        if (b.data?.['Authorization']) delete b.data['Authorization'];
      }
    }

    // Strip request body on credential endpoints
    const url = event.request?.url ?? '';
    if (url.includes('/credentials/')) {
      if (event.request) event.request.data = null;
      // Strip query params — they may contain IDs the user searched for
      if (event.request?.url) {
        try {
          const u = new URL(event.request.url);
          u.search = '';
          event.request.url = u.toString();
        } catch {
          // not a parseable URL; leave as-is
        }
      }
    }

    // Drop email from user context; keep only ID for correlation
    if (event.user?.email) delete event.user.email;

    return event;
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
